namespace $.$$ {

	$mol_style_define( $shm_hitalama_profile_switch, {
		whiteSpace: 'nowrap',
	} )

}
